/**
 * Copyright © Veeam Software Group GmbH.
 */

export const DEFAULT_BV365_USER_QOUTA = 1;
